import { TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { AUTOFILL_OPT_OUT } from '@/lib/constants/autofill-opt-out';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = ({
  ref,
  className,
  ...props
}: TextareaProps & { ref?: React.Ref<HTMLTextAreaElement> }) => {
  return (
    <textarea
      className={cn(
        'border-input bg-background placeholder:text-muted-foreground focus-visible:ring-ring/70 flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm shadow-sm focus-visible:ring-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...AUTOFILL_OPT_OUT}
      {...props}
    />
  );
};
Textarea.displayName = 'Textarea';

export { Textarea };
